import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Checkbox } from "antd"

import Modal from "../reusable/modal"

import { usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'

const EditLocum = ({ toggle, visible, request, onPerform }) => {
    const { user } = useSelector(state => state.application)

    const [name, setName] = useState(request?.name ?? user?.name)
    const [description, setDescription] = useState(request?.description)
    const [department, setDepartment] = useState(request?.department)
    const [phone, setPhone] = useState(request?.phone)

    const onComplete = (_, notify, ops) => {
        notify(request ? 'Changes have been saved' : 'Request has been sent', ops('success'))
        onPerform()
        setTimeout(toggle, 200)
    }

    const [{ loading: newLoading }, newLocumRequest] = usePet('newLocumRequest', {
        requestedFor: name,
        description,
        department,
        phone
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Sending Locum Request...' } })

    const [{ loading: editLoading }, editLocumRequest] = usePet('editLocumRequest', {
        id: request?._id,
        requestedFor: name,
        description,
        department,
        phone
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Saving Changes...' } })

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break
                
            case 'description':
                setDescription(e.target.value)
                break
                
            case 'phone':
                setPhone(e.target.value)
                break

            case 'department':
                setDepartment(e.target.value)
                break

            default:
                break
        }
    }

    return (
        <Modal
            w={ 400 }
            title={ request ? "Edit Locum Request" : "Send Locum Request" }
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        type="text"
                        name="name"
                        value={ name }
                        onChange={ modify }
                        placeholder="Evans Kimani" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Department
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-department"
                        type="text"
                        name="department"
                        value={ department }
                        onChange={ modify }
                        placeholder="Nursing" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Phone Number
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-phone"
                        type="text"
                        name="phone"
                        value={ phone }
                        onChange={ modify }
                        placeholder="07XXXXXXXX" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Description
                    </label>
                    <textarea
                        rows="5"
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-description"
                        type="text"
                        name="description"
                        value={ description }
                        onChange={ modify }
                        placeholder="Describe work done" />
                </div>
            </div>
            <div className="flex justify-end mt-3">
                <button onClick={ request ? editLocumRequest : newLocumRequest } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default EditLocum